import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import useRole from '../../../hooks/useRole';
import { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import PreferenceGeneralise from '../../Expert/Profile/PreferenceGeneralise';
import SideBarAddExpert from './SideBarAddExpert';

function AjouterExpertStep3() {
    const { i18n } = useTranslation();
    const role=useRole();
    // const getQueryParam = (param) => {
    //     const url = window.location.href; // Get the full URL
    //     const queryString = url.split('?')[1]; // Get everything after the "?"
    //     const params = new URLSearchParams(queryString); // Parse the query string
    //     return params.get(param); // Return the value of the parameter
    // };

    // const isDossierCandidat = getQueryParam('isDossierCandidat')=='true';
    // let param = useParams();
    const location = useLocation();
    const {isCandidat}=location.state || {};
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Gestion des Experts')} &gt;<span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Ajouter un Expert')} </span> </div>
                <div style={{display:'flex',flexDirection:'row',alignSelf:'stretch',gap:'24px'}}>
                    <SideBarAddExpert role={role}/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:'80%',alignItems: 'center',gap:'24px'}}>
                        {role &&
                            <PreferenceGeneralise
                                isDoCandidat={isCandidat}
                                typeTraitement={role=='esn' ? (isCandidat==true ? typeTraitementEnum.COLLAB_ESN_ADD_DOSSIER_CANDIDAT: typeTraitementEnum.COLLAB_ESN_ADD_EXPERT ) : typeTraitementEnum.ADMIN_ADD_EXPERT}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
}
export default AjouterExpertStep3;